import { render } from "./RoomChoose.vue?vue&type=template&id=fd382886"
import script from "./RoomChoose.vue?vue&type=script&lang=js"
export * from "./RoomChoose.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/MT/2025/jebsen/files/components/com_cruise/assets/js/booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__